import SmoothScroll from "smooth-scroll";
import MicroModal from "micromodal";

const inputPolicy = document.querySelector('input[type="checkbox"]');
const submitButton = document.querySelector('input[type="submit"]');

// スムーススクロール
var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 100,
  speedAsDuration: true,
});

// モーダルウィンドウ
modalWindow();
function modalWindow() {
  MicroModal.init({
    openClass: "is-open",
    disableScroll: true,
  });
}

// 送信ボタン
if (inputPolicy) {
  submitActive();
}

function submitActive() {
  inputPolicy.addEventListener("change", function () {
    if (this.checked) {
      submitButton.classList.add("active");
    } else {
      submitButton.classList.remove("active");
    }
  });
}

// ハンバーガーメニュー
menuActive();
function menuActive() {
  const body = document.querySelector("body");
  const menuButton = document.querySelector(".header__menu");
  const menu = document.querySelector(".menu");
  const menuClose = document.querySelector(".menu__close");
  const menuLink = document.querySelectorAll(".menu a");

  menuButton.addEventListener("click", function () {
    menu.classList.add("active");
    body.classList.add("active");
  });

  menuClose.addEventListener("click", function () {
    menu.classList.remove("active");
    body.classList.remove("active");
  });

  menuLink.forEach(function (elm) {
    elm.addEventListener("click", function () {
      menu.classList.remove("active");
      body.classList.remove("active");
    });
  });
}
